<script setup lang="ts">
import type { Licence } from "~/types/licence"
import type { RouteLocationRaw } from "vue-router"
import { NuxtLink } from "#components"

const props = defineProps<{ licence: Licence }>()

const products = useProductVariantsStore()

const to = computed<RouteLocationRaw | undefined>(() => {
  for (const product of products.productsList) {
    for (const variant of product.variants) {
      if (variant.ean === props.licence.ean) {
        return {
          name: "variant",
          params: {
            product: product.productKey,
            variant: variant.variantKey,
          },
        }
      }
    }
  }
})
</script>

<template>
  <component
    :is="to ? NuxtLink : 'div'"
    :to="to"
    class="mb-10 flex flex-col items-start justify-start gap-4 hover:cursor-pointer hover:brightness-[85%] md:flex-row"
    tabindex="0"
    :aria-label="to ? ('Bytt til produktet ' + licence.name) : undefined"
  >
    <UProductImage
      :product="licence"
      class="size-44 min-w-44 rounded bg-[--theme-lightest] p-2"
      img-class="size-full rounded object-contain"
    />
    <div class="flex flex-col gap-2">
      <p class="font-bold font-national2" v-text="licence.name" />
      <p class="font-light font-national2">
        Tilgang til
        <NuxtTime :datetime="licence.endDate" locale="nb-NO" date-style="long" />
        (utløper automatisk)
      </p>
      <p />
    </div>
  </component>
</template>
